import { Component, OnInit } from '@angular/core';
import { Dashboard } from 'src/shared/models/dashboard.model';
import { SharedDashboardService } from './shared-dashboard.service';

@Component({
    selector: 'cv-shared-dashboard',
    templateUrl: './shared-dashboard.component.html',
    styleUrls: ['./shared-dashboard.component.scss']
})
export class SharedDashboardComponent implements OnInit {
    dashboard: Dashboard = null;
    loadingDashboard = true;
    dashboardGUID: string;
    urlOptions: Map<string, string> = new Map<string, string>();

    constructor(
        private service: SharedDashboardService,
    ) { }

    ngOnInit() {
        if (window.location.search) {
            // break up url
            const queriedOptions = window.location.search.split('&');
            queriedOptions.forEach(option => {
                const kvPair = option.split('=');
                this.urlOptions.set(kvPair[0].replace('?',''), kvPair[1]);
            });
        }
        if (this.urlOptions.has('id')) {
            this.getDashboard(this.urlOptions.get('id'));
        }
    }

    async getDashboard(sharedKey: string) {
        this.dashboard = await this.service.getDashboard(sharedKey);
        this.loadingDashboard = false;
    }
}
